import React, { useState } from "react";
import axios from "axios";

const ServerIP = "https://kiwuibackend.onrender.com"; // adapte cette URL à ton backend réel

export default function DeleteAccountPage() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [isVisible, setIsVisible] = useState(false); // loader visible

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsVisible(true);
    setError("");

    try {
      const deleteData = { phone, password };

      await axios.post(`${ServerIP}/driver/deleteAccount`, deleteData)
        .then(res => {
          console.log(res.data);
          setSubmitted(true);
        })
        .catch(err => {
          // axios error can be in err.response.data.message ou err.message
          const msg = err.response?.data?.message || err.message || "Erreur inconnue";
          setError(msg);
        });

    } catch (err) {
      setError(err.message);
    }

    setIsVisible(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-10 text-gray-800 font-sans">
      <div className="max-w-2xl mx-auto bg-white shadow-xl rounded-2xl p-6 md:p-10">
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Suppression de compte Kiwui Chauffeur
        </h1>

        {!submitted ? (
          <>
            <p className="mb-4">
              Vous pouvez supprimer définitivement votre compte Kiwui Chauffeur.
              Cette action est <strong>irréversible</strong> et entraînera :
            </p>
            <ul className="list-disc list-inside mb-6 space-y-1">
              <li>La suppression de toutes vos données personnelles.</li>
              <li>La perte d'accès à l'historique de vos courses, livraisons et revenus.</li>
              <li>L'impossibilité de récupérer votre compte une fois supprimé.</li>
            </ul>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="phone" className="block font-semibold mb-1">
                  Numéro de téléphone
                </label>
                <input
                  type="tel"
                  id="phone"
                  required
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="ex: +509 1234 5678"
                  className="w-full p-2 border border-gray-300 rounded-xl"
                />
              </div>

              <div>
                <label htmlFor="password" className="block font-semibold mb-1">
                  Mot de passe
                </label>
                <input
                  type="password"
                  id="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-xl"
                />
              </div>

              {error && <p className="text-red-600">{error}</p>}

              <button
                type="submit"
                disabled={isVisible}
                className="w-full bg-red-600 text-white py-2 rounded-xl hover:bg-red-700 transition disabled:opacity-50"
              >
                {isVisible ? "Suppression en cours..." : "Supprimer mon compte"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-green-600">
            <p className="text-xl font-semibold mb-2">Votre demande a été envoyée.</p>
            <p>
              Nous allons vérifier vos informations et procéder à la suppression de votre compte
              dans les plus brefs délais.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}